export async function enableMocking() {
  if (window.flatfile.configService.get('VITE_ENABLE_BROWSER_MSW') !== 'true') {
    return
  }

  const { worker } = await import('./browser')

  // `worker.start()` returns a Promise that resolves
  // once the Service Worker is up and ready to intercept requests.
  return worker.start()
}
